import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Tooltip from '../tooltip';
import Icon from '../icon';
import HelpContext from '../../contexts/help-context';
import I18n from '../i18n';
import config from '../../config';

const WINDOW_TARGET = 'vhthelp';

export default function HelpTooltip(props) {
  const {topic, className, ...rest} = props;
  const helpTopics = React.useContext(HelpContext);
  const topicData = helpTopics[topic];
  let message = topic;

  // This is a fix for Firefox on OSX. It seems that in that browser/OS combo clicking a button does not give it focus.
  // See: https://gist.github.com/cvrebert/68659d0333a578d75372
  // Since the help tooltip visibility is bound to the button focus, this resulted in the help tooltip not showing.
  // Manually calling focus on the button to programatically set focus correctly.
  const ensureFocus = React.useCallback(evt => evt.currentTarget.focus());

  if (!topicData || !topicData.Text) {
    console.warn(`No help found for topic ${topic}.`);
    message = (
      <span>
        <a href={config.helpCenterUrl} target={WINDOW_TARGET} rel="noopener">
          <I18n t="help-not-found" />
        </a>
      </span>
    );
  } else {
    message = (
      <span>
        {topicData.Text}{' '}
        {topicData.URL && (
          <a href={topicData.URL} target={WINDOW_TARGET} rel="noopener">
            <I18n t="action.help-read-more" />
          </a>
        )}
      </span>
    );
  }

  return (
    <Tooltip trigger="focus" placement="auto" message={message} className="help-tooltip">
      <button
        type="button"
        className={classnames('btn', 'btn-help-section', className)}
        data-help={topic}
        onClick={ensureFocus}
        {...rest}
      >
        <Icon icon="question-circle" />
      </button>
    </Tooltip>
  );
}

HelpTooltip.propTypes = {
  /** The help topic name. */
  topic: PropTypes.string.isRequired,
  /** Optionally a className to add to the HTML element. */
  className: PropTypes.string,
};
